<template>
    <div>
        <button
            class="btn btn-white btn-color-picker"
            type="button"
            :id="_uid"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <div class="d-flex">
                <div
                    class="rounded color-preview mr-1"
                    :class="{
                        'border border-gray': ['#ffffff', 'transparent'].includes(markerColors[value]),
                    }"
                    :style="{
                        'background-color': markerColors[value],
                    }"
                ></div>
                <div>
                    <span class="icon icon-xs icon-glyphicons-basic-chevron-down text-secondary"></span>
                </div>
            </div>
        </button>
        <div class="dropdown-menu dropdown-menu-right color-dropdown" :aria-labelledby="_uid">
            <a v-for="color in markerColorOptions" :key="color" class="dropdown-item" @click="selectColor(color)">
                <div v-show="color == 'transparent'" class="rounded color-preview text-center">
                    <span class="text-secondary tiny align-middle">Invisible</span>
                </div>
                <div
                    v-show="color != 'transparent'"
                    class="rounded color-preview"
                    :class="{
                        'border border-gray': markerColors[color] == '#ffffff',
                    }"
                    :style="{
                        'background-color': markerColors[color],
                    }"
                ></div>
            </a>
        </div>
    </div>
</template>

<script>
import { hotspotColors } from "@/assets/js/settings.js"

export default {
    name: "HotspotColorPicker",
    props: {
        value: {
            type: String,
            required: false,
            default: "",
        },
    },
    data() {
        return {
            markerColors: hotspotColors,
        }
    },
    computed: {
        markerColorOptions() {
            return Object.keys(this.markerColors)
        },
    },
    methods: {
        selectColor(color) {
            this.$emit("input", color)
        },
    },
}
</script>

<style lang="scss" scoped>
.color-preview {
    height: 25px;
    width: 38px;
}

.color-dropdown {
    max-width: 6rem;
    min-width: 5rem !important;
}

.btn-color-picker {
    padding: 3px;
}
</style>